import { MAX_EFFICE_CONTENT_CHARS } from "constants/constants";
import SendButton from "graphics/icons/SendButton";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectData } from "slices/efficeCacheSlice";
import { createNewEffice, selectCurrentActive } from "slices/efficeTreeSlice";
import {
  ALL_MEMBERS_TEXT_TYPE,
  ONLY_ADMIN_TEXT_TYPE,
} from "slices/peopleSlice";
import { selectCurrentSpaceId } from "slices/spaceSlice";
import { setInputBoxActive } from "slices/generalSlice";
import { FM_INPUTENTRY } from "helpers/freshman";
import HlpInputEntry from "components/HelpSlides/InEffice/HlpInputEntry";
import HelperTip from "components/HOCS/HelperTip";
import { isEscapeKey } from "helpers/navShortcuts";
import { iAmAdmin } from "helpers/efficeHelpers";

const DONT_ENTER_TO_SEND = "dont_enter_to_send";

const checkDontEnterToSend = () =>
  localStorage.getItem(DONT_ENTER_TO_SEND) !== null;

function setDontEnterToSend(val) {
  if (val) localStorage.setItem(DONT_ENTER_TO_SEND, "true");
  else localStorage.removeItem(DONT_ENTER_TO_SEND);
}

const InputEntry = ({ textContentRef }) => {
  const [inputValue, setInputValue] = useState("");
  const [enterToSend, setEnterToSend] = useState(!checkDontEnterToSend());
  const ref = useRef();
  const dispatch = useDispatch();
  const currentActive = useSelector(selectCurrentActive);
  const currentSpaceId = useSelector(selectCurrentSpaceId);

  const data = useSelector(selectData);

  let amAdmin = iAmAdmin(data[currentActive]);
  let onlyAdminsCanText = data[currentActive]?.type === ONLY_ADMIN_TEXT_TYPE;
  let allMembersCanText = data[currentActive]?.type === ALL_MEMBERS_TEXT_TYPE;
  let canText = allMembersCanText || (onlyAdminsCanText && amAdmin);

  useEffect(() => {
    if (enterToSend === checkDontEnterToSend())
      setDontEnterToSend(!enterToSend);
  }, [enterToSend]);

  useEffect(() => {
    if (ref.current) {
      if (canText) {
        ref.current.scrollTop = ref.current.scrollHeight;
        ref.current.style.height = "35px";
        ref.current.style.height = ref.current.scrollHeight + 2 + "px";
      } else {
        ref.current.style.removeProperty("height");
      }
    }
  }, [inputValue, canText]);

  const onSubmit = () => {
    let trimmedValue = inputValue.trim();
    if (trimmedValue.length !== 0) {
      dispatch(createNewEffice(currentActive, false, trimmedValue, false));
    }
    setInputValue(""); // will have optimistic update
  };

  return (
    <HelperTip
      code={FM_INPUTENTRY}
      placement="top"
      component={<HlpInputEntry />}
      style={{ width: "355px" }}
      lazy
    >
      <div className={`Txt-input-bar ${currentSpaceId ? "space-active" : ""}`}>
        <div className="w-100">
          <div className="Txt-input-entry-margins">
            {canText ? (
              <>
                <div
                  className={`Txt-input-entry-container ${
                    inputValue ? "active" : ""
                  }`}
                >
                  <textarea
                    className="Txt-input-entry"
                    value={inputValue}
                    maxLength={MAX_EFFICE_CONTENT_CHARS}
                    placeholder="Text"
                    onKeyDown={(e) => {
                      if (
                        e.key === "Enter" &&
                        e.shiftKey === false &&
                        enterToSend
                      ) {
                        onSubmit();
                        e.preventDefault();
                        if (textContentRef.current)
                          textContentRef.current.scrollTop =
                            textContentRef.current.scrollHeight;
                      }
                      if (isEscapeKey(e)) {
                        document.activeElement.blur();
                        e.stopPropagation();
                      }
                    }}
                    onChange={(e) => setInputValue(e.target.value)}
                    ref={ref}
                    onFocus={() => dispatch(setInputBoxActive(true))}
                    onBlur={() => dispatch(setInputBoxActive(false))}
                  />
                  <button
                    className={`Txt-make-effice-button ${
                      inputValue ? "active" : ""
                    }`}
                    disabled={!inputValue}
                    onClick={onSubmit}
                  >
                    <div className="Txt-send-button-svg">
                      <SendButton />
                    </div>
                    <div className="Txt-send-button-word">Send</div>
                  </button>
                </div>
                <div className="Txt-input-help">
                  {onlyAdminsCanText && !amAdmin ? (
                    "Only Admins Can Type Here"
                  ) : (
                    <>
                      <input
                        id="checkboxa"
                        type="checkbox"
                        checked={enterToSend}
                        onChange={() => setEnterToSend(!enterToSend)}
                      />
                      <label htmlFor="checkboxa">Enter to Send</label>
                    </>
                  )}
                </div>
              </>
            ) : (
              <div className={`Txt-input-entry-container no-type`}>
                <textarea
                  className="Txt-input-entry disabled"
                  placeholder="Only admins can type in here"
                  disabled={true}
                  style={{ height: "40px" }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </HelperTip>
  );
};

export default InputEntry;
